import * as yup from "yup";
import { Message } from "yup/lib/types";

export const formResolverContract = (t: (arg0: string) => Message) => {
  return yup.object().shape({
    inn: yup.string().nullable().required(t("validation.required")),
    code: yup.string().nullable().required(t("validation.required")),
    category: yup.string().nullable().required(t("validation.required")),
    isHeadCompany: yup
      .string()
      .nullable()
      .required(t("validation.required"))
      .oneOf(["Да", "Нет"]),
    contractNumber: yup.string().nullable().required(t("validation.required")),
    contractDate: yup.string().nullable().required(t("validation.required")),
    avtovazAccount: yup
      .mixed()
      .test("", t("validation.required"), (value) => {
        return (
          (typeof value === "object" && value !== null) ||
          typeof value === "string"
        );
      })
      .nullable()
      .required(t("validation.required")),
    avtovazBank: yup.string().nullable().required(t("validation.required")),
    accountStartDate: yup
      .string()
      .nullable()
      .required(t("validation.required")),
    confidantId: yup.object().nullable().required(t("validation.required")),
    printFormId: yup.object().nullable().required(t("validation.required")),
    // ПОКА НЕОБЯЗАТЕЛЬНЫЕ ПОЛЯ
    // startPrintDate: yup.string().nullable().required(t("validation.required")),
    // endPrintDate: yup.string().nullable().required(t("validation.required")),
    // closeDateForIS: yup.string().nullable().required(t("validation.required")),
    // dealerSignedDate: yup
    //   .string()
    //   .nullable()
    //   .required(t("validation.required")),
    // workStartDate: yup.string().nullable().required(t("validation.required")),
  });
};

export const formResolverAdditional = (t: (arg0: string) => Message) => {
  return yup.object().shape({
    inn: yup.string().nullable().required(t("validation.required")),
    code: yup.string().nullable().required(t("validation.required")),
    category: yup.string().nullable().required(t("validation.required")),
    isHeadCompany: yup
      .string()
      .nullable()
      .required(t("validation.required"))
      .oneOf(["Да", "Нет"]),
    contractNumberParent: yup
      .string()
      .nullable()
      .required(t("validation.required")),
    contractDateParent: yup
      .string()
      .nullable()
      .required(t("validation.required")),
    parentContractId: yup
      .string()
      .nullable()
      .required(t("validation.required")),
    contractNumber: yup.string().nullable().required(t("validation.required")),
    contractDate: yup.string().nullable().required(t("validation.required")),
    startForPrint: yup.string().nullable().required(t("validation.required")),
    closeForPrint: yup.string().nullable().required(t("validation.required")),
    confidantId: yup.object().nullable().required(t("validation.required")),
    printFormId: yup.object().nullable().required(t("validation.required")),
    // ПОКА НЕОБЯЗАТЕЛЬНЫЕ ПОЛЯ
    // startDateForIS: yup.string().nullable().required(t("validation.required")),
    // closeDateForIS: yup.string().nullable().required(t("validation.required")),
    // dealerSignedDate: yup
    //   .string()
    //   .nullable()
    //   .required(t("validation.required")),
    // ursosSignedDate: yup.string().nullable().required(t("validation.required")),
  });
};
